// import { motion } from "framer-motion";
// import useChatBot from "../hooks/useChatBot";
// import MessageIcon from "@mui/icons-material/Message";
// import { LOGO } from "../../utility/constains";

// const ChatBot = () => {
//   const {
//     isOpen,
//     toggleChat,
//     messages,
//     input,
//     setInput,
//     isInputDisabled,
//     emailRequest,
//     currentOption,
//     handleSend,
//     handleOptionSelect,
//     handlePartnershipSelection,
//     handleSkip,
//   } = useChatBot();

//   return (
//     <div className="fixed bottom-8 right-4 z-30">
//       {!isOpen && (
//         <motion.button
//           className="bg-[#228b22] text-white p-4 rounded-full"
//           onClick={toggleChat}
//           whileHover={{ scale: 1.1 }}
//         >
//           <MessageIcon />
//         </motion.button>
//       )}
//       {isOpen && (
//         <motion.div
//           className="w-full sm:w-[20rem] md:w-[24rem] lg:w-[28rem] h-[80vh] md:h-[550px] bg-white rounded-lg shadow-lg overflow-hidden relative"
//           initial={{ opacity: 0, y: 100 }}
//           animate={{ opacity: 1, y: 0 }}
//           exit={{ opacity: 0, y: 100 }}
//           transition={{ duration: 0.5 }}
//         >
//           {/* Header */}
//           <div className="bg-[#2d486f] p-4 text-white flex items-center rounded-t-xl">
//             <img
//               src={LOGO}
//               alt="Profile"
//               className="rounded-full w-10 h-10 bg-white object-contain"
//             />
//             <div className="ml-3">
//               <h2 className="font-bold text-lg font-heading tracking-widest">
//                 Tara
//               </h2>
//               <p className="text-sm tracking-wider font-body">
//                 Hi, I am Tara, your assistant here...
//               </p>
//             </div>
//             <motion.button
//               className="absolute top-3 right-3 text-black p-1 bg-white rounded-full"
//               whileHover={{ scale: 1.2, rotate: 90 }}
//               whileTap={{ scale: 0.9 }}
//               onClick={toggleChat}
//             >
//               ✖
//             </motion.button>
//           </div>

//           {/* Chat Body */}
//           <div className="p-4 h-72 sm:h-80 md:h-96 overflow-y-auto noScrollbar">
//             {messages.map((msg, index) => (
//               <div
//                 key={index}
//                 className={`${
//                   msg.from === "bot" ? "text-left" : "text-right"
//                 } my-2`}
//               >
//                 <span
//                   className={`inline-block p-2 rounded-xl px-3 font-body ${
//                     msg.from === "bot"
//                       ? "bg-gray-100 text-gray-700"
//                       : "bg-green-500 text-white"
//                   }`}
//                 >
//                   {msg.text}
//                 </span>
//               </div>
//             ))}

//             {/* Partnership options */}
//             {currentOption === "Partnership Assistance" && (
//               <div className="flex flex-col gap-2 mt-3 bg-gray-100 rounded-3xl shadow-sm">
//                 {[
//                   "Vendor Partnership",
//                   "Design Partnership",
//                   "Store Partnership",
//                   "Handyman Partnership",
//                   "Corporate Partnership",
//                   "Project Partnership",
//                 ].map((option) => (
//                   <motion.button
//                     key={option}
//                     className="bg-white mx-4 my-2 p-2 text-gray-800 py-2 px-4 rounded-full"
//                     onClick={() => handlePartnershipSelection(option)}
//                     whileHover={{ scale: 1.06 }}
//                   >
//                     {option}
//                   </motion.button>
//                 ))}
//               </div>
//             )}

//             {/* Skip Button */}
//             {currentOption && (
//               <div className="mt-4 text-right">
//                 <motion.p
//                   className="text-gray-700 font-body py-2 rounded-xl px-4 cursor-pointer"
//                   whileHover={{ scale: 1.02 }}
//                   onClick={handleSkip}
//                 >
//                   Skip >>
//                 </motion.p>
//               </div>
//             )}

//             {/* Option buttons */}
//             {!currentOption && (
//               <div className="flex flex-wrap gap-2 mt-3">
//                 <motion.button
//                   className="border border-gray-400 bg-[#f0f8ff] text-black font-body py-2 px-4 rounded-full"
//                   onClick={() => handleOptionSelect("Services")}
//                   whileHover={{ scale: 1.05 }}
//                 >
//                   Services
//                 </motion.button>
//                 <motion.button
//                   className="border border-gray-400 bg-[#f0f8ff] text-black font-body py-2 px-4 rounded-full"
//                   onClick={() => handleOptionSelect("Partnership Assistance")}
//                   whileHover={{ scale: 1.05 }}
//                 >
//                   Partnership Assistance
//                 </motion.button>
//                 <motion.button
//                   className="border border-gray-400 bg-[#f0f8ff] text-black font-body py-2 px-4 rounded-full"
//                   onClick={() => handleOptionSelect("Helpdesk")}
//                   whileHover={{ scale: 1.05 }}
//                 >
//                   Helpdesk
//                 </motion.button>
//               </div>
//             )}
//           </div>

//           {/* Input Area */}
//           <div className="p-2 flex border-t">
//             {emailRequest ? (
//               <>
//                 <motion.input
//                   type="text"
//                   className="flex-grow py-2 px-4 border rounded-l-lg focus:outline-none my-3 bg-white"
//                   value={input}
//                   placeholder="Enter your email"
//                   onChange={(e) => setInput(e.target.value)}
//                   onKeyDown={(e) => e.key === "Enter" && handleSend()}
//                   disabled={isInputDisabled}
//                   whileHover={{ scale: 1.02 }}
//                 />
//                 <motion.button
//                   className={`bg-[#228b22] p-2 rounded-r-lg text-white my-3 ${
//                     isInputDisabled ? "opacity-50 cursor-not-allowed" : ""
//                   }`}
//                   onClick={handleSend}
//                   disabled={isInputDisabled}
//                   whileHover={{ scale: 1.06 }}
//                 >
//                   Send
//                 </motion.button>
//               </>
//             ) : (
//               <div className="flex-grow py-2 px-4 border rounded-lg my-3 bg-gray-50 font-bodytext-gray-100 flex items-center justify-center">
//                 <p>{currentOption ? currentOption : "No option selected"}</p>
//               </div>
//             )}
//           </div>
//         </motion.div>
//       )}
//     </div>
//   );
// };

// export default ChatBot;

import { motion } from "framer-motion";
import useChatBot from "../hooks/useChatBot";
import MessageIcon from "@mui/icons-material/Message";
import ChatHeader from "./ChatHeader";
import MessageList from "./MessageList";
import OptionButtons from "./OptionButtons";
import InputField from "./InputField";

const ChatBot = () => {
  const {
    isOpen,
    toggleChat,
    messages,
    input,
    setInput,
    isInputDisabled,
    emailRequest,
    currentOption,
    handleSend,
    handleOptionSelect,
    handlePartnershipSelection,
    handleSkip,
  } = useChatBot();

  return (
    <div className="fixed bottom-8 right-4 z-30">
      {!isOpen && (
        <motion.button
          className="bg-[#228b22] text-white p-4 rounded-full"
          onClick={toggleChat}
          whileHover={{ scale: 1.1 }}
        >
          <MessageIcon />
        </motion.button>
      )}
      {isOpen && (
        <motion.div
          className="w-full sm:w-[20rem] md:w-[24rem] lg:w-[28rem] h-[80vh] md:h-[550px] bg-white rounded-lg shadow-lg overflow-hidden relative "
          initial={{ opacity: 0, y: 100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.5 }}
        >
          <ChatHeader toggleChat={toggleChat} />
          <MessageList
            messages={messages}
            currentOption={currentOption}
            handlePartnershipSelection={handlePartnershipSelection}
            handleSkip={handleSkip}
          />
          <OptionButtons
            currentOption={currentOption}
            handleOptionSelect={handleOptionSelect}
          />
          <InputField
            input={input}
            setInput={setInput}
            handleSend={handleSend}
            emailRequest={emailRequest}
            isInputDisabled={isInputDisabled}
            currentOption={currentOption}
          />
        </motion.div>
      )}
    </div>
  );
};

export default ChatBot;
